module.exports = __webpack_public_path__ + "font/fontello.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_mavon-editor@2.9.1@mavon-editor/dist/font/fontello.woff2
// module id = 43
// module chunks = 0